// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getBaseUrl } from '../../../redux/modules/config';
import LACrown from './LACrown';

const mapStateToProps = state => {
    return {
        baseUrl: getBaseUrl(state),
    };
};

type Props = {|
    baseUrl: string,
|};

class LACrownContainer extends Component<Props> {
    render() {
        const { baseUrl } = this.props;

        return <LACrown baseUrl={baseUrl} />;
    }
}

export default connect(mapStateToProps)(LACrownContainer);
